import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-common-mall-coupon',
    templateUrl: './common-mall-coupon.component.html',
    styleUrls: ['./common-mall-coupon.component.scss'],
    standalone: false
})
export class CommonMallCouponComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
